module.exports = __webpack_public_path__ + "static/img/4@2x.b3daae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/barometer/4@2x.png
// module id = Az5a
// module chunks = 1